import { useEffect, useState } from "react";

import Lightbox from "../../common/Lightbox";

import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { ITask } from "../../../data_models/task";
import { IFreelancer } from "../../../data_models/freelancer";
import { Application } from "../../../data_models/application";
import useApplications from "../../../hooks/useApplications";
import { getFreelancerName } from "../../../utils/freelancerUtils";


interface ApplicationAcceptLightboxProps {
    applicationId: string;
    task: ITask;
    freelancer: IFreelancer;
    onClose: () => void;
    onUpdateApplication: (application: Application) => void;

}

const ApplicationAcceptLightbox: React.FC<ApplicationAcceptLightboxProps> = ({ applicationId, task, freelancer, onClose, onUpdateApplication }) => {


    const [loading, setLoading] = useState(false);

    const { acceptApplication } = useApplications();
    const { addErrorNotification, addSuccessNotification } = useDisplayNotifications();



    const onAcceptApplication = async () => {
        try {
            setLoading(true);
            const result = await acceptApplication(applicationId);
            onUpdateApplication(result);
            addSuccessNotification(`Successfully accepted ${getFreelancerName(freelancer)}'s application for ${task.title}.`);
        } catch (error: any) {
            addErrorNotification(error.message, "Accept Application Failed");
        } finally {
            setLoading(false);
            onClose();
        }
    }

    return (
        <Lightbox
            header="Accept Application"
            content={
                <div className="flex flex-col items-start space-y-3" >
                    <p>Are you sure you want to accept <b>{getFreelancerName(freelancer)}</b>'s application for <b>{task.title}</b>?</p>

                </div>}
            confirmText="Accept"
            onConfirm={onAcceptApplication}
            loadingConfirm={loading}

            onCancel={onClose}
            onClose={onClose}

        />

    );
}

export default ApplicationAcceptLightbox;
